<template>

  <div>
    <label
      class="btn btn-sm btn-light btn-file"
      :class="{'box-loading': loading}"
      style="margin: 0">
      {{ selectLabel || $t('Select image') }}
      <input
        type="file"
        @change="uploadFile($event)"
        style="display: none;">
    </label>
    <button
      v-if="removeOption && value"
      class="btn btn-sm btn-light btn-file"
      @click="removeFile">
      {{ removeLabel }}
    </button>
  </div>

</template>

<script>
// import FileReader from '@/utils/FileReader'

export default {
  name: 'InputOnePhoto',
  components: {
  },
  props: {
    'value': {
      type: [Array, Object, String],
      default: null
    },
    'selectLabel': {
      type: String,
      default: null
    },
    'removeLabel': {
      type: String,
      default: 'Remover'
    },
    'removeOption': {
      type: Boolean,
      default: false
    }
  },
  computed: {
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    uploadFile (event) {
      this.loading = true

      const file = event.target.files[0]

      const formData = new FormData()
      formData.append('file', file)
      return this.$store.dispatch('createMediaMultipart', formData).then((result) => {
        this.loading = false
        this.$emit('input', result)
      })

      // return FileReader(file)
      // .then((base64) => {
      //   return {
      //     'title': file.name,
      //     'base64': base64
      //   }
      // })
      // .then((data) => {
      //   return this.$store
      //   .dispatch('createMedia', data)
      // })
      // .then((result) => {
      //   this.loading = false
      //   this.$emit('input', result)
      // })
    },
    removeFile () {
      this.$emit('input', null)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Fields/InputOnePhoto.vue